module.exports = __webpack_public_path__ + "lt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lt.svg
// module id = 923
// module chunks = 0